import React from 'react';
import { Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';

type TBadgeVariant = 'error' | 'warning';

interface IVariantStyle {
  backgroundColor: string;
  textColor: string;
}

type TVariantStyles = Record<TBadgeVariant, IVariantStyle>;

interface IProps {
  variant: TBadgeVariant;
  label: string;
  className?: string;
  testId?: string;
  dataCy?: string;
  style?: React.CSSProperties;
}

const variantStyles: TVariantStyles = {
  error: {
    backgroundColor: colors.error[50],
    textColor: colors.error[500],
  },
  warning: {
    backgroundColor: colors.warning[50],
    textColor: colors.warning[700],
  },
};

/**
 * Badge Component
 *
 * Renders a badge with a specified variant and label.
 *
 * @example
 * <Badge variant="error" label="Error" />
 * <Badge variant="warning" label="Warning" />
 */
export const Badge: React.FC<IProps> = ({ variant, label, testId, dataCy, style }) => {
  const styles = variantStyles[variant];

  return (
    <Typography
      as="span"
      color={styles.textColor}
      size="caption"
      bold
      uppercase
      data-testid={testId}
      data-cy={dataCy}
      style={{
        backgroundColor: styles.backgroundColor,
        borderRadius: 3,
        paddingBlock: 2,
        paddingInline: 7,
        width: 'fit-content',
        ...style,
      }}
    >
      {label}
    </Typography>
  );
};
